import React from "react";
import { Container, Row } from "reactstrap";
import { NavLink } from "react-router-dom";

const Portfolio = () => {
  return (
    <Container fluid className="portfolio-section">
      <Row xs="1" md="2" className="full-height">
        <div>
          <NavLink to="/graphics">Graphics</NavLink>
        </div>
        <div>
          <NavLink to="/web">Web</NavLink>
        </div>
        <div>
          <NavLink to="/coding">Coding</NavLink>
        </div>
        <div>
          <NavLink to="/photography">Photography</NavLink>
        </div>
      </Row>
    </Container>
  );
};

export default Portfolio;
